import {DocumentUpdateMessageHandler} from 'notebook/realtime/DocumentUpdateMessageHandler';
import {displayNotification} from 'notebook/realtime/DocumentUpdateNotifications';
import {fetchAndUpdateFileLockState} from 'notebook/realtime/DocumentUpdatesManager';
import {RealtimeMessageType} from 'realtime/Constants';

export const lockUpdateMessageHandler: DocumentUpdateMessageHandler<typeof RealtimeMessageType.LOCK_UPDATE> =
  {
    active: (fileId, {lock, userNotifications}) => {
      if (userNotifications) {
        for (const notification of userNotifications) {
          displayNotification(notification);
        }
      }
      fetchAndUpdateFileLockState(fileId, lock);
    },
  };
